var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-my-sm"},[_c('strong',[_vm._v(_vm._s(_vm.field.label))]),_vm._l((_vm.field.options),function(option){return _c('div',{key:option.id},[(_vm.on_call_settings.options_staffing[option.id])?_c('div',[_c('on-call-field-option',{attrs:{"option":option}})],1):_vm._e()])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }